import React from "react";
import "../styles/About.css";

import unity from "../assets/toolLogos/unity.webp";
import git from "../assets/toolLogos/git.webp";
import figma from "../assets/toolLogos/figma.webp";
import procreate from "../assets/toolLogos/procreate.webp";
import oculus from "../assets/toolLogos/oculus.webp";
import mrtk from "../assets/toolLogos/mrtk.webp";

const tools = [
  { name: "Unity", logo: unity, link: "https://unity.com/de" },
  { name: "Git", logo: git, link: "https://git-scm.com/" },
  { name: "Figma", logo: figma, link: "https://www.figma.com/de-de/" },
  { name: "Procreate", logo: procreate, link: "https://procreate.com/" },
  { name: "Oculus", logo: oculus, link: "https://www.meta.com/de/quest/" },
  {
    name: "MRTK",
    logo: mrtk,
    link: "https://learn.microsoft.com/de-de/windows/mixed-reality/mrtk-unity/mrtk2/?view=mrtkunity-2022-05",
  },
];

const About: React.FC = () => {
  return (
    <section className="about section" id="about">
      <h1>about me</h1>
      <div className="about-content">
        <div className="about-text-container">
          <p className="about-text">
          Hi there! I'm a software developer with a passion for games, mixed reality, and all things creative.
          After studying Media Informatics in Leipzig, I completed a Master's in International Media and Computing in Berlin,
          specialising in interactive technologies and user-centred experiences.
          <br /><br />
          I work in an agile and collaborative way, combining structured development practices with creativity and curiosity.
          I also use AI tools to boost my productivity, such as generating ideas, optimising workflows and exploring new technologies.
          <br /><br />
          When I'm not coding or prototyping, you'll probably find me tending to my virtual farm in Stardew Valley,
          discovering new music (live shows are the best!), or working on a creative project, whether digital or analogue.
          I believe that great ideas emerge where technology and imagination meet, and I’m always excited by new challenges and collaborations.
          </p>
        </div>
        <div className="tools-container">
          <p>Tools I have worked with:</p>
          <div className="tools-grid">
            {tools.map((tool, index) => (
              <a
                href={tool.link}
                key={index}
                className="tool-item"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={tool.logo} alt={tool.name} className="tool-logo" />
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
